export const LINKEDIN_URL = "https://www.linkedin.com/in/a-agrawal01/";

export const GITHUB_URL = "https://github.com/Ayush5601";

export const EMAIL = "mailto:ayush123ngp@gmail.com";

export const RESUME_URL =
  "https://drive.google.com/file/d/1Ld5YLSCA3bxiU27JDn9X3tvdY4MHHNzg/view?usp=drive_link";
